import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type PackagePlanOfferFieldsFragment = {
	__typename?: 'PackagePlanOffer';
	title?: string | null;
	retailPrice?: string | null;
	retailPriceConverted?: string | null;
	retailPriceValue?: number | null;
	currency?: string | null;
	presentationType?: Types.PresentationType | null;
	isTrial?: boolean | null;
	durationDays?: number | null;
	children: Array<{
		__typename?: 'PackagePlanOffer';
		title?: string | null;
		retailPrice?: string | null;
		isTrial?: boolean | null;
		durationDays?: number | null;
		retailPriceValue?: number | null;
	}>;
};

export const PackagePlanOfferFieldsFragmentDoc = gql`
	fragment PackagePlanOfferFields on PackagePlanOffer {
		title
		retailPrice(language: $language)
		retailPriceConverted(language: $language)
		retailPriceValue
		currency
		presentationType
		isTrial
		durationDays
		children {
			title
			retailPrice(language: $language)
			isTrial
			durationDays
			retailPriceValue
		}
	}
`;
